import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { insertSpacesBetweenWords } from "helpers/filters.ts";

const FormValidationMessage = ({ errorMessageObj = {} }) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const errorsList = Object.keys(errorMessageObj);

  if (errorsList.length === 0) {
    return null;
  }
  if (errorsList.length > 0) {
    const message = errorMessageObj[errorsList[0]].message;
    const type = errorMessageObj[errorsList[0]].type;
    // here is specifying all error messages

    switch (true) {
      case type === "maxLength":
        return (
          <div className="invalid-notification">
            <Icon name="warning" red />
            <span className="invalid-notification-name">
              {insertSpacesBetweenWords(errorsList[0])}
            </span>
            <span>{getTextByKey("max-length-limit")?.toLowerCase()}</span>
          </div>
        );

      case message?.includes("774892"):
        return (
          <div className="invalid-notification">
            <Icon name="warning" red />
            {getTextByKey("error-invalid-code-message")}
          </div>
        );

      default:
        return (
          <div className="invalid-notification">
            <Icon name="warning" red />
            {getHtmlByKey(message) ||
              message ||
              getTextByKey("default-input-invalid-message")}
          </div>
        );
    }
  }
};

export default FormValidationMessage;
